export default __webpack_public_path__ + "static/media/mastercard.58c5e976.svg";